import React, { Component } from 'react'

import {
  Switch,
  Route
} from 'react-router-dom'

import NaviBar from './components/NaviBar'
import NaviIconMenu from './components/NaviIconMenu'
import Footer from '../common/component/Footer'
import Login from './pages/public/Login'
import PasswordReset from './pages/public/PasswordReset'
import Dashboard from './pages/secure/Dashboard'
import InformationList from './pages/secure/InformationList'
import InformationEdit from './pages/secure/InformationEdit'
import InformationDetail from './pages/secure/InformationDetail'
import SharedFileList from './pages/secure/SharedFileList'
import SharedFileEdit from './pages/secure/SharedFileEdit'
import SharedFileDetail from './pages/secure/SharedFileDetail'

import RoutineTaskHome from './pages/secure/RoutineTaskHome'
import SystemSettingHome from './pages/secure/SystemSettingHome'

import SurveySettingHome from './pages/secure/SurveySettingHome'
import SurveySettingList from './pages/secure/SurveySettingList'
import SurveySettingEdit from './pages/secure/SurveySettingEdit'
import SurveyBigQuestionList from './pages/secure/SurveyBigQuestionList'
import SurveyMediumQuestionList from './pages/secure/SurveyMediumQuestionList'
import SurveySmallQuestionList from './pages/secure/SurveySmallQuestionList'
import SurveyBigQuestionEdit from './pages/secure/SurveyBigQuestionEdit'
import SurveyMediumQuestionEdit from './pages/secure/SurveyMediumQuestionEdit'
import SurveySmallQuestionEdit from './pages/secure/SurveySmallQuestionEdit'

import PersonalSettingHome from './pages/secure/PersonalSettingHome'
import PasswordChange from './pages/secure/PasswordChange'
import EmailChange from './pages/secure/EmailChange'
import NotificationSettingChange from './pages/secure/NotificationSettingChange'

import CompanyList from './pages/secure/CompanyList'
import CompanyEdit from './pages/secure/CompanyEdit'
import CompanyDetail from './pages/secure/CompanyDetail'

import CompanyUserEdit from './pages/secure/CompanyUserEdit'
import CompanyUserDetail from './pages/secure/CompanyUserDetail'

import DefaultSetting from './pages/secure/DefaultSetting'

import AdminUserList from './pages/secure/AdminUserList'
import AdminUserEdit from './pages/secure/AdminUserEdit'
import AdminUserDetail from './pages/secure/AdminUserDetail'

import AWSAPI from '../common/AWSAPI'

class AdminApp extends Component {
  renderPublicPages () {
    return (
      <div>
        <Switch>
          <Route exact path='/admin/password_reset' component={PasswordReset} />
          <Route exact path='/admin/login' component={Login} />
          <Route component={Login} />
        </Switch>
      </div>
    )
  }
  renderSecurePages () {
    return (
      <div>
        <NaviBar history={this.props.history} />
        <div id='body-container'>
          <div id='body-content'>
            <NaviIconMenu history={this.props.history} />
            <Switch>
              <Route exact path='/admin/information' component={InformationList} />
              <Route exact path='/admin/information/add' component={InformationEdit} />
              <Route exact path='/admin/information/edit/:id' component={InformationEdit} />
              <Route exact path='/admin/information/detail/:id' component={InformationDetail} />

              <Route exact path='/admin/shared_files' component={SharedFileList} />
              <Route exact path='/admin/shared_files/add' component={SharedFileEdit} />
              <Route exact path='/admin/shared_files/edit/:id' component={SharedFileEdit} />
              <Route exact path='/admin/shared_files/detail/:id' component={SharedFileDetail} />

              <Route exact path='/admin/routine_task_home' component={RoutineTaskHome} />
              <Route exact path='/admin/system_setting_home' component={SystemSettingHome} />

              <Route exact path='/admin/survey_setting_home' component={SurveySettingHome} />
              <Route exact path='/admin/survey_setting' component={SurveySettingList} />
              <Route exact path='/admin/survey_setting/add' component={SurveySettingEdit} />
              <Route exact path='/admin/survey_setting/edit/:id' component={SurveySettingEdit} />
              <Route exact path='/admin/survey_bigquestion' component={SurveyBigQuestionList} />
              <Route exact path='/admin/survey_bigquestion/add' component={SurveyBigQuestionEdit} />
              <Route exact path='/admin/survey_bigquestion/edit/:id' component={SurveyBigQuestionEdit} />
              <Route exact path='/admin/survey_mediumquestion/:id' component={SurveyMediumQuestionList} />
              <Route exact path='/admin/survey_mediumquestion/add/:id' component={SurveyMediumQuestionEdit} />
              <Route exact path='/admin/survey_mediumquestion/edit/:id' component={SurveyMediumQuestionEdit} />
              <Route exact path='/admin/survey_smallquestion/:id' component={SurveySmallQuestionList} />
              <Route exact path='/admin/survey_smallquestion/add/:id' component={SurveySmallQuestionEdit} />
              <Route exact path='/admin/survey_smallquestion/edit/:id' component={SurveySmallQuestionEdit} />

              <Route exact path='/admin/personal_setting_home' component={PersonalSettingHome} />
              <Route exact path='/admin/password_change' component={PasswordChange} />
              <Route exact path='/admin/email_change' component={EmailChange} />
              <Route exact path='/admin/notification_setting_change' component={NotificationSettingChange} />

              <Route exact path='/admin/default_setting' component={DefaultSetting} />

              <Route exact path='/admin/admin_user' component={AdminUserList} />
              <Route exact path='/admin/admin_user/add' component={AdminUserEdit} />
              <Route exact path='/admin/admin_user/edit/:id' component={AdminUserEdit} />
              <Route exact path='/admin/admin_user/detail/:id' component={AdminUserDetail} />

              <Route exact path='/admin/company' component={CompanyList} />
              <Route exact path='/admin/company/add' component={CompanyEdit} />
              <Route exact path='/admin/company/edit/:id' component={CompanyEdit} />
              <Route exact path='/admin/company/detail/:id' component={CompanyDetail} />

              <Route exact path='/admin/company_user/add/:parentID' component={CompanyUserEdit} />
              <Route exact path='/admin/company_user/edit/:parentID/:id' component={CompanyUserEdit} />
              <Route exact path='/admin/company_user/detail/:parentID/:id' component={CompanyUserDetail} />
              <Route component={Dashboard} />
            </Switch>
          </div>
        </div>
        <Footer />
      </div>
    )
  }

  render () {
    let view = null
    if (AWSAPI.isLoggedIn('admin')) {
      view = this.renderSecurePages()
    } else {
      view = this.renderPublicPages()
    }
    return view
  }
}

export default AdminApp



// WEBPACK FOOTER //
// ./src/admin/AdminApp.js